// extracted by mini-css-extract-plugin
export default {"highlighted":"MenuBar_highlighted__1xAYG"};